export default "__VITE_ASSET__DM_Uw1P4__"